<template>
  <button class="CloseButton">
    <svg viewBox="0 0 21 21">
      <path d="M1,1 L20,20 M1,20 L20,1" stroke-width="3" stroke="currentColor" fill="none" />
    </svg>
  </button>
</template>

<style scoped>

.CloseButton {
  color: var(--main-color, var(--text-color-black));
  transition: all 0.15s;
}

.CloseButton:hover {
  opacity: 0.85;
}

.CloseButton svg {
  width: 21px;
  height: 21px;
}

.CloseButton.--large svg {
  width: 24px;
  height: 24px;
}
</style>
